import React from 'react'
import { ApplicationSlidingTutorial } from './application-sliding-tutorial'
import { ApplicationsSlidingTutorial } from './applications-sliding-tutorial'
import { LibrariesSlidingTutorial } from './libraries-sliding-tutorial'
import { VulnerabilitiesSlidingTutorial } from './vulnerabilities-sliding-tutorial'
import { ProtectSlidingTutorial } from './protect-sliding-tutorial'
import { TutorialsQuery } from './tutorials-query'
import { Tutorial } from '../../graphql/schema/queries/tutorials'

export function SlidingTutorial(props: {
  readonly isOpen: boolean
  readonly isVisible: boolean
  readonly tutorialKey: Tutorial
  readonly orgUuid: string
  readonly zIndex: number
  readonly appId?: string
  readonly yOffset?: number
}) {
  const TutorialVersion = tutorialLookup[props.tutorialKey]

  return typeof TutorialVersion === 'function' && props.isVisible ? (
    <TutorialsQuery organizationID={props.orgUuid}>
      {(tutorials) => {
        return (
          <TutorialVersion
            {...props}
            isOpen={tutorials.tutorials.indexOf(props.tutorialKey) < 0}
          />
        )
      }}
    </TutorialsQuery>
  ) : null
}

const tutorialLookup = {
  ATTACKS: ProtectSlidingTutorial,
  APP_VULNERABILITIES: VulnerabilitiesSlidingTutorial,
  APP_LIBRARIES: LibrariesSlidingTutorial,
  APP_OVERVIEW: ApplicationSlidingTutorial,
  APPLICATIONS: ApplicationsSlidingTutorial
}
